import { createCustomEnum } from "./customEnum";

const ReconciliationStatuses = createCustomEnum({
	Pending: {
		value: 0,
		name: "pending",
		displayName: "Pending",
	},
	CompleteNoIssues: {
		value: 1,
		name: "completeNoIssues",
		displayName: "Complete - no issues",
	},
	CompleteIssuesAccepted: {
		value: 2,
		name: "completeIssuesAccepted",
		displayName: "Complete - issues accepted",
	},
	RequiresMapping: {
		value: 3,
		name: "requiresMapping",
		displayName: "Requires mapping & re-import",
	},
	RequiresReImport: {
		value: 4,
		name: "requiresReImport",
		displayName: "Requires re-import",
	},
	NotApplicable: {
		value: 5,
		name: "notApplicable",
		displayName: "Not applicable",
	},
});

export default ReconciliationStatuses;
